import React from 'react';
import { MinusIcon, PlusIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import { ActionsBox, ActionButton } from './RcsChat.styles';

/**
 * Popover component that shows a Text-From-911 chat's participants
 * @param {Boolean} showStartChat - Flag for rendering this component
 * @param {Boolean} isChatBoxVisible - Flag for expanding/collapsing the chat
 * @param {Function} onActionButtonClick - Onclick handler for toggling the
 * isTextFrom911ChatBoxVisible flag
 */
const RcsParticipantsPopover = ({
  showStartChat,
  isChatBoxVisible,
  onActionButtonClick,
}) => {
  if (showStartChat) {
    return null;
  }
  return (
    <Box>
      <ActionsBox>
        <ActionButton noMargin showBorder onClick={onActionButtonClick}>
          {!isChatBoxVisible ? (
            <PlusIcon width={14} height={14} color="secondaryText" />
          ) : (
            <MinusIcon width={12} height={12} color="secondaryText" />
          )}
        </ActionButton>
      </ActionsBox>
    </Box>
  );
};

export default RcsParticipantsPopover;
